import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { isApplePlatform } from '@/lib/platform';
import { cn } from '@/lib/utils';

import { useCommandCenterStore } from '../stores/command-center.store';

export function CommandCenterTrigger({ className }: { className?: string }) {
    const { t } = useTranslation();
    const open = useCommandCenterStore((s) => s.open);

    return (
        <>
            {/* Desktop: search pill */}
            <Button
                variant="outline"
                onClick={open}
                className={cn(
                    'text-muted-foreground hidden h-8 w-56 justify-between px-3 text-sm font-normal md:flex',
                    className,
                )}
            >
                <span className="flex items-center gap-2 truncate">
                    <Search className="size-3.5" />
                    {t('commandCenter.trigger', 'Search or jump to…')}
                </span>
                <kbd className="bg-muted pointer-events-none rounded border px-1.5 font-mono text-[10px]">
                    {isApplePlatform() ? '⌘K' : 'Ctrl K'}
                </kbd>
            </Button>
            {/* Mobile: icon only */}
            <Button variant="ghost" size="icon-sm" onClick={open} className="md:hidden">
                <Search className="size-4.5" />
            </Button>
        </>
    );
}
